import { createRxDatabase, addRxPlugin, RxDatabase } from 'rxdb';
import { getRxStorageDexie } from 'rxdb/plugins/storage-dexie';
import { RxDBQueryBuilderPlugin } from 'rxdb/plugins/query-builder';
import { RxDBMigrationPlugin } from 'rxdb/plugins/migration';

import { productSchema } from './schemas/product.schema';
import { categorySchema } from './schemas/category.schema';
import { orderSchema } from './schemas/order.schema';
import { customerSchema } from './schemas/customer.schema';
import { settingSchema } from './schemas/setting.schema';
import { syncMetaSchema, syncMetaMigrationStrategies } from './schemas/sync-meta.schema';
import { unitSchema } from './schemas/unit.schema';
import { supplierSchema } from './schemas/supplier.schema';
import { purchaseOrderSchema } from './schemas/purchaseOrder.schema';
import { stockAdjustmentSchema } from './schemas/stockAdjustment.schema';

addRxPlugin(RxDBQueryBuilderPlugin);
addRxPlugin(RxDBMigrationPlugin);

let dbInstance: RxDatabase | null = null;

export async function createDatabase(name: string = 'lancarpos') {
  if (dbInstance) {
    return dbInstance;
  }

  const db = await createRxDatabase({
    name,
    storage: getRxStorageDexie(),
    multiInstance: true,
    eventReduce: true,
    ignoreDuplicate: true,
  });

  await db.addCollections({
    products: { schema: productSchema },
    categories: { schema: categorySchema },
    orders: { schema: orderSchema },
    customers: { schema: customerSchema },
    settings: { schema: settingSchema },
    units: { schema: unitSchema },
    sync_meta: { 
      schema: syncMetaSchema,
      migrationStrategies: syncMetaMigrationStrategies,
    },
    suppliers: { schema: supplierSchema },
    purchase_orders: { schema: purchaseOrderSchema },
    stock_adjustments: { schema: stockAdjustmentSchema },
  });

  dbInstance = db;
  return db;
}

export type LancarPOSDatabase = Awaited<ReturnType<typeof createDatabase>>;

export async function clearDatabase(db: LancarPOSDatabase) {
  await Promise.all([
    db.products.find().remove(),
    db.categories.find().remove(),
    db.orders.find().remove(),
    db.customers.find().remove(),
    db.settings.find().remove(),
    db.units.find().remove(),
    db.sync_meta.find().remove(),
    db.suppliers.find().remove(),
    db.purchase_orders.find().remove(),
    db.stock_adjustments.find().remove(),
  ]);
}
